import { render, staticRenderFns } from "./systematics_list.vue?vue&type=template&id=ec1e7a9a&scoped=true"
import script from "./systematics_list.vue?vue&type=script&lang=ts"
export * from "./systematics_list.vue?vue&type=script&lang=ts"
import style0 from "./systematics_list.vue?vue&type=style&index=0&id=ec1e7a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1e7a9a",
  null
  
)

export default component.exports